/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade } from '../transition/Fade';
import { ModalBase } from '../modal/ModalBase';
import { SwipeableDrawer } from './SwipeableDrawer';
import { PositionedDrawer } from './PositionedDrawer';
import { useBreakpoint } from '../hooks/useBreakpoint';

const Drawer = React.forwardRef((props, ref) => {

  const {
    container,
    open,
    onClose,
    fixed,
    position,
    children
  } = props;

  const screen = useBreakpoint('md');
  const isSmall = screen.lesser;

  const gridClasses = classNames('sui-h-full', {
    'landscape:sui-grid landscape:sui-grid-cols-12 landscape:sui-gap-4': isSmall,
    'sui-grid sui-grid-cols-12 sui-gap-4': !isSmall
  });

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      ref={ref}
      container={container}
    >
      <Fade in={open} classes={gridClasses}>
        {isSmall && (
          <SwipeableDrawer fixed={fixed}>
            {children}
          </SwipeableDrawer>
        )}
        {!isSmall && (
          <PositionedDrawer position={position}>
            {children}
          </PositionedDrawer>
        )}
      </Fade>
    </ModalBase>
  );
});

Drawer.displayName = 'Drawer';

Drawer.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  position: PropTypes.oneOf(['left', 'right']),
  fixed: PropTypes.bool
};

Drawer.defaultProps = {
  position: 'right',
  fixed: false,
};

export { Drawer };